//====================================================
//  Initialization Map
//====================================================


function fn_components_object_map(){
    $('.object-map .map-block').each(function() {
        var inst = $(this);
        var id = inst.attr('id');
        fn_components_map_init(id);
    });

    // if ($('.map-objects-info').length){
    //     $('.map-objects-info input').bind('change', function(){
    //         var state = [];
    //         $('.map-objects-info input').each(function() {
    //             if ($(this).prop('checked') == true){
    //                 state.push($(this).prop('id'));
    //             }
    //         });
    //     });
    // }

}



function fn_components_map_init(mapId){
	var map
    var mapOptions = {
        zoom: 8,
        panControl: false,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        scrollwheel: false,
        //draggable: false,
        center: new google.maps.LatLng(50.0809813, 14.396636),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles:[{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#64d8ff"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}]
    };
    map = new google.maps.Map(document.getElementById(mapId), mapOptions);

    var gmarkers = [];
    var bounds = new google.maps.LatLngBounds();
    var objects = [];
    
    if (mapId == 'map-object-detail'){
        var markers = [
            {
                "id": '1',
                "type": '1',
                "icon": 'public/img/marker-active.svg',
                "active": true,
                "longitude": 50.091922,
                "latitude": 14.423461,
                "link": "detail.html",
                "image": 'public/img/product-image-1.jpg',
                "price": '1 200 000 Kč',
                "title": 'Rodinný dům 4+1',
                "place": 'Šumperk, Revoluční 45',
                "typeText": 'pronajem',
                "area": '203 m2',
                "dispozition": '4+kk'
            }, {
                "id": '2',
                "type": '1',
                "icon": 'public/img/marker-house.svg',
                "active": false,
                "longitude": 50.090564,
                "latitude": 14.413077,
                "link": "detail.html",
                "image": 'public/img/product-image-1.jpg',
                "price": '1 200 000 Kč',
                "title": 'Rodinný dům 4+1',
                "place": 'Šumperk, Revoluční 45',
                "typeText": 'prodej',
                "area": '203 m2',
                "dispozition": '4+kk'
            }, {
                "id": '3',
                "type": '1',
                "icon": 'public/img/marker-house.svg',
                "active": false,
                "longitude": 50.090802,
                "latitude": 14.463077,
                "link": "detail.html",
                "image": 'public/img/product-image-1.jpg',
                "price": '1 200 000 Kč',
                "title": 'Rodinný dům 4+1',
                "place": 'Šumperk, Revoluční 45',
                "typeText": 'prodej',
                "area": '203 m2',
                "dispozition": '4+kk'
            }
        ]
    } else {
        var markers = [
            {
                "id": '1',
                "type": '3',
                "icon": 'public/img/marker-other.svg',
                "active": false,
                "longitude": 50.091922,
                "latitude": 14.423461,
                "link": "detail.html",
                "image": 'public/img/product-image-1.jpg',
                "price": '1 200 000 Kč',
                "title": 'Rodinný dům 4+1',
                "place": 'Šumperk, Revoluční 45',
                "typeText": 'pronajem',
                "area": '203 m2',
                "dispozition": '4+kk'
            }, {
                "id": '2',
                "type": '1',
                "icon": 'public/img/marker-house.svg',
                "active": false,
                "longitude": 50.090564,
                "latitude": 14.413077,
                "link": "detail.html",
                "image": 'public/img/product-image-1.jpg',
                "price": '1 200 000 Kč',
                "title": 'Rodinný dům 4+1',
                "place": 'Šumperk, Revoluční 45',
                "typeText": 'prodej',
                "area": '203 m2',
                "dispozition": '4+kk'
            }, {
                "id": '3',
                "type": '2',
                "icon": 'public/img/marker-commerce.svg',
                "active": false,
                "longitude": 50.090802,
                "latitude": 14.463077,
                "link": "detail.html",
                "image": 'public/img/product-image-1.jpg',
                "price": '1 200 000 Kč',
                "title": 'Rodinný dům 4+1',
                "place": 'Šumperk, Revoluční 45',
                "typeText": 'prodej',
                "area": '203 m2',
                "dispozition": '4+kk'
            }, {
                "id": '4',
                "type": '1',
                "icon": 'public/img/marker-house.svg',
                "active": false,
                "longitude": 50.110702,
                "latitude": 14.403077,
                "link": "detail.html",
                "image": 'public/img/product-image-1.jpg',
                "price": '1 200 000 Kč',
                "title": 'Rodinný dům 4+1',
                "place": 'Šumperk, Revoluční 45',
                "typeText": 'prodej',
                "area": '203 m2',
                "dispozition": '4+kk'
            }, {
                "id": '5',
                "type": '2',
                "icon": 'public/img/marker-commerce.svg',
                "active": false,
                "longitude": 50.099702,
                "latitude": 14.463077,
                "link": "detail.html",
                "image": 'public/img/product-image-1.jpg',
                "price": '1 200 000 Kč',
                "title": 'Rodinný dům 4+1',
                "place": 'Šumperk, Revoluční 45',
                "typeText": 'prodej',
                "area": '203 m2',
                "dispozition": '4+kk'
            }
        ]
    }


    for (var i = 0; i < markers.length; ++i) {
        var template = '<a href="'+ markers[i].link +'" class="item">' +
                            '<div class="image-block"><img src="'+ markers[i].image +'" alt="" class="img-responsive"></div>' +
                            '<div class="content">' +
                              '<div class="price-block"><span class="price">'+ markers[i].price +'</span></div>' +
                              '<div class="text-block">' +
                                '<h3 class="title">'+ markers[i].title +'</h3><span class="type">'+ markers[i].place +'</span>' +
                              '</div>' +
                              '<div class="info-block row gutter-10">' +
                                '<div class="icon-block col-xs-4"><span class="icon icon-prodej"></span><span class="text text-uppercase">'+ markers[i].typeText +'</span></div>' +
                                '<div class="icon-block col-xs-4"><span class="icon icon-rozloha"></span><span class="text">'+ markers[i].area +'</span></div>' +
                                '<div class="icon-block col-xs-4"><span class="icon icon-dispozice"></span><span class="text">'+ markers[i].dispozition +'</span></div>' +
                              '</div>' +
                            '</div>' +
                        '</a>'
        objects.push(template);
    }


    for (var i = 0; i < markers.length; ++i) {
        var latLng = new google.maps.LatLng(markers[i].longitude, markers[i].latitude)
        var marker = new google.maps.Marker({
            position: latLng,
            draggable: false,
            icon: markers[i].icon,
            id: markers[i].id,
            type: markers[i].type,
            active: markers[i].active,
            name: objects[i]
        });

        var infoWindow = new google.maps.InfoWindow({
            maxWidth: 270
        }), marker, i;

        google.maps.event.addListener(marker, 'click', function(e){
            if (this.id.length){
                infoWindow.setContent(this.name);
                infoWindow.open(map, this);
                $('.gm-style-iw').parent().addClass('window-block');
                fn_setBackgroundClass(this.type, this.active);
            }
        });

        google.maps.event.addListener(infoWindow, 'domready', function() {
            var iwOuter = $('.gm-style-iw');
            var iwBackground = iwOuter.prev();
            iwBackground.children(':nth-child(2)').css({'display' : 'none'});
            iwBackground.children(':nth-child(4)').css({'display' : 'none'});

            var iwCloseBtn = iwOuter.next();
            iwCloseBtn.css({width: '40px', height:'40px', opacity: '1', right: '7px', top: '60px', 'border-radius': '100px'});
            iwCloseBtn.mouseout(function(){
                $(this).css({opacity: '1'});
            });

        });


        bounds.extend(marker.position);
        marker.setMap(map);
        gmarkers.push(marker);
    }

    map.fitBounds(bounds);
}



function fn_setBackgroundClass(type, active){
    var backgroundClass, activeClass = " ";
    if (type == 1) backgroundClass = "house";
    if (type == 2) backgroundClass = "commerce";
    if (type == 3) backgroundClass = "other";
    if (active == true) activeClass = "active";
    $('.gm-style-iw').parent().removeClass().addClass('window-block ' + backgroundClass + ' ' +  activeClass);
}